<template>
  <div
    class="container-bg p-3 custom-scrollbar"
    style="height: 350px; box-shadow: unset;"
  >
    <div class="flex-container mt-0">
      <div
        class="nav nav-tabs nav-fill"
        id="nav-tab"
        role="tablist"
        style="display: unset; border-bottom: unset"
      >
        <a
          class="btn text-white btn-dark active item tab-styling"
          id="nav-next-event"
          data-toggle="tab"
          aria-controls="next-event"
          href="#next-event"
          role="tab"
          aria-selected="true"
          @click="nextEvent"
        >
          Komend event
        </a>
        <a
          class="btn text-white btn-dark item tab-styling"
          data-toggle="tab"
          href="#upcomming-event"
          role="tab"
          aria-selected="false"
          @click="upcomingEvents"
          >Aankomende events</a
        >
        <a
          class="btn text-white btn-dark item tab-styling"
          data-toggle="tab"
          href="#calender-event"
          role="tab"
          aria-selected="false"
          @click="mount_calendar = !mount_calendar"
          >Agenda</a
        >
        <i
          v-if="canAddEvent"
          class="fa fa-plus item"
          style="font-size: 24px; flex: unset; margin: 4px; cursor: pointer"
          data-toggle="modal"
          data-target="#eventModal"
          @click="addNewEvent"
        ></i>
      </div>
    </div>
    <div class="tab-content" id="nav-tabContent" v-if="events.length">
      <div
        v-if="next_event"
        id="next-event"
        class="tab-pane fade show active"
        role="tabpanel"
        style="background-color: unset !important"
      >
        <div
          class="flex-container p-2"
          style="cursor: pointer"
          :class="[
            next_event.attend != null && next_event.attend.pivot.attend == 1
              ? 'flex-body'
              : 'attendance',
          ]"
          @click="
            setUserAttend(
              next_event.attend != null && next_event.attend.pivot.attend == 1
                ? 0
                : 1,
              next_event.id,
              $store.state.auth.user.id
            )
          "
        >
          <div
            class="item text-white pr-2"
            style="flex: 0; border-right: 1px solid"
          >
            <h4 style="margin: 0">{{ next_event.day_month_duration.day }}</h4>
            <p class="text-uppercase mb-0">
              {{ next_event.day_month_duration.month }}
            </p>
            <div class="h6 text-center mb-0" v-if="next_event.canceled">
              <i class="fa fa-times text-danger"></i>
            </div>
          </div>
          <div class="item text-white" style="flex: 18">
            <p style="margin: 0">
              {{ next_event.title }} van
              {{ next_event.day_month_duration.duration }}
            </p>
          </div>
          <div class="item">
            <i
              @click.stop="editEvent(next_event)"
              v-if="
                $store.state.auth.user &&
                  $store.state.auth.user.id ==
                    getEventTypeSetting(next_event.eventtype).absence_user_id
              "
              class="text-white fa fa-edit"
            >
            </i>

            <i
              @click.stop="openEvent(next_event)"
              class="text-white fa fa-eye ml-2"
            >
            </i>
          </div>
        </div>

        <div
          class="modal fade"
          id="absentieModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="absentieModal"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <absence :next-event="next_event"></absence>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- upcoming events start-->
      <div
        id="upcomming-event"
        class="tab-pane fade"
        role="tabpanel"
        style="background-color: unset !important"
      >
        <div
          v-for="(event, index) in events"
          :key="index"
          class="flex-container flex-body p-2"
        >
          <div
            class="item text-white pr-2"
            style="flex: 0; border-right: 1px solid"
          >
            <h4 style="margin: 0">
              {{ event.day_month_duration.day }}
            </h4>
            <p class="text-uppercase">
              {{ event.day_month_duration.month }}
            </p>
          </div>
          <div class="item text-white" style="flex: 18">
            <!-- TODO EVENT EDIT -->
            <!-- <a
                      class="event-btn-edit"
                      href="#eventModal"
                      @click="eventEdit(event)"
                      data-toggle="modal"
                      ><i class="fas fa-edit"></i
                    ></a> -->
            <p style="margin: 0">
              {{ event.title }} van
              {{ event.day_month_duration.duration }}
            </p>
          </div>
          <div class="item">
            <i
              @click.stop="openEvent(event)"
              class="text-white fa fa-eye ml-2 cursor-pointer"
            >
            </i>
            <button
              v-if="
                $store.state.auth.user &&
                  $store.state.auth.user.id ==
                    getEventTypeSetting(event.eventtype).absence_user_id
              "
              @click="absentieEvent(event)"
              class="btn btn-dark btn-sm text-white"
              data-toggle="modal"
              data-target="#absentieModal"
            >
              Absentie
            </button>
            <button
              v-else-if="
                getEventTypeSetting(next_event.eventtype)
                  .absence_by_attendees &&
                  next_event.attend != null &&
                  next_event.attend.pivot.attend
              "
              @click="
                setUserAttend(0, event.id, event.attend.pivot.attendee_id)
              "
              class="btn btn-dark btn-sm text-white"
            >
              Afmelden
            </button>
            <button
              v-else-if="
                getEventTypeSetting(event.eventtype).absence_by_attendees &&
                  next_event.attend != null &&
                  next_event.attend.pivot.attend == 0
              "
              @click="
                setUserAttend(1, event.id, event.attend.pivot.attendee_id)
              "
              class="btn btn-dark btn-sm text-white"
            >
              Aanmelden
            </button>
            <div
              class="modal fade"
              id="absentieModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="absentieModal"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-body">
                    <absence :next-event="event"></absence>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button
            @click="loadMore"
            class="mt-2 btn btn-small-mvn btn-sm btn-dark text-white"
          >
            Laad meer
          </button>
        </div>
      </div>
      <!-- upcoming events end -->
      <!-- calender start-->
      <div
        id="calender-event"
        class="tab-pane fade mt-2"
        role="tabpanel"
        style="background-color: unset !important"
      >
        <Calendar
          v-if="mount_calendar"
          is-expanded
          v-on:update:to-page="agendaEvents"
          :attributes="calendar_events"
        >
          <template #day-popover="{ day, attributes }">
            <div class="text-xs text-gray-300 font-semibold text-center">
              {{ day.day + "-" + day.month + "-" + day.year }}
              <div>{{ attributes[0].customData.description }}</div>
            </div>
          </template>
        </Calendar>

        <!-- <div
          v-for="(event, index) in events"
          :key="index"
          class="flex-container flex-body p-2"
        >
          <div
            class="item text-white pr-2"
            style="flex: 0; border-right: 1px solid"
          >
            <h4 style="margin: 0">
              {{ event.day_month_duration.day }}
            </h4>
            <p class="text-uppercase">
              {{ event.day_month_duration.month }}
            </p>
          </div>
          <div class="item text-white" style="flex: 18">
            <p style="margin: 0">
              {{ event.title }} van
              {{ event.day_month_duration.duration }}
            </p>
          </div>
        </div> -->
        <!-- <div class="d-flex justify-content-center">
          <button
            @click="loadMore"
            class="mt-2 btn btn-small-mvn btn-sm btn-dark text-white"
          >
            Laad meer
          </button>
        </div> -->
      </div>
      <!-- calender end -->
    </div>

    <div
      class="modal fade"
      id="eventDetailsModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 1000px">
        <event-details
          :event="openedEvent"
          :eventtypes="eventtypes"
          :committees="committees"
          :settings="getEventTypeSetting(openedEvent.eventtype)"
          :key="forceUpdateKey"
          @triggerGetEvent="nextEvent()"
        ></event-details>
      </div>
    </div>

    <!--       Event modal start-->
    <div
      class="modal fade"
      id="eventModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="min-width: 999px">
        <event-form
          :committee="committee"
          :event="event"
          :eventtypes="eventtypes"
          :force-update="forceUpdateKey"
          :key="forceUpdateKey"
        ></event-form>
      </div>
    </div>
  </div>
</template>

<script>
import Calendar from "v-calendar/lib/components/calendar.umd";
import Absence from "../../events/absence.vue";
import EventDetails from "../../events/event_details.vue";
import EventForm from "../../events/event_form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Calendar, Absence, EventDetails, EventForm },
  props: {
    id: {
      type: Number,
    },
    canAddEvent: {
      type: Boolean,
      default: false,
    },
    committees: {
      type: Array,
    },
  },
  data() {
    return {
      committee: null,
      events: [],
      eventtypes: [],
      next_event: {},
      calendar_events: [],
      filter_type: "next",
      filter_page: 1,
      filter_date: null,
      selected_month: null,
      create_event: {},
      errormsg: "",
      eventtype_config: null,
      event_selected_committees: [],
      mount_calendar: false,
      openedEvent: {},
      forceUpdateKey: 0,
      event: {},
    };
  },
  computed: {
    ...mapState({
      selectedMembers: (state) => state.selectedMembers,
    }),
  },
  methods: {
    ...mapActions({
      displayNotification: "auth/displayNotification",
    }),
    addNewEvent() {
      this.event = {};
      this.forceUpdate();
    },
    editEvent(event) {
      event.attendees = event.attendees.map((user) => {
        user.selected = user.pivot.attend == 1 ? true : false;
        return user;
      });
      this.event = event;
      console.log(this.event);
      window.$("#eventModal").modal("show");
      this.forceUpdateKey++;
    },
    getEventTypeSetting(eventtype) {
      var settings = {};
      if (eventtype != null) {
        try {
          settings = JSON.parse(eventtype.settings);
        } catch (e) {
          console.log(e);
        }
      }
      // console.log(settings);
      return settings;
    },
    forceUpdate() {
      this.forceUpdateKey++;
    },
    openEvent(event) {
      this.openedEvent = event;
      this.forceUpdate();
      window.$("#eventDetailsModal").modal("show");
    },
    nextEvent() {
      this.filter_type = "next";
      this.resetValues();
      this.getEvents();
    },
    upcomingEvents() {
      this.filter_type = "upcoming";
      this.resetValues();
      this.getEvents();
    },

    agendaEvents(to_page) {
      this.filter_type = "agenda";
      this.resetValues();
      this.filter_date = `${to_page.year}-${to_page.month}-01`;
      this.getEvents();
    },
    resetValues() {
      this.filter_page = 1;
      this.filter_date = null;
    },
    loadMore() {
      this.filter_page++;
      this.getEvents();
    },
    setUserAttend(value, event_id, user_id) {
      console.log("REQUEST...");
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/event-attend",
          details: {
            attend: value,
            event_id: event_id,
            user_id: user_id,
          },
        })
        .then((data) => {
          if (value == 0) {
            this.displayNotification({
              type: "success",
              title: "Success",
              message: "U bent voor de activiteit afgemeld",
              id: Math.round(Math.random() * 999),
              autoDismiss: true,
              interval: 2000,
            });
          } else {
            this.displayNotification({
              type: "success",
              title: "Success",
              message: "U bent voor de activiteit aangemeld",
              id: Math.round(Math.random() * 999),
              autoDismiss: true,
              interval: 2000,
            });
          }
          this.nextEvent();
          // window.location.reload();
          console.log(data.data);
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    getEvents() {
      let id = this.id ?? "";
      this.$store
        .dispatch(
          "get",
          `api/v1/get-committee-events/${id}?type=${this.filter_type}&date=${this.filter_date}&page=${this.filter_page}`
        )
        .then((data) => {
          if (this.id && this.id > 0) this.committee = data.data.data;

          this.events = [...data.data.data.events_with_eventtypes];

          this.eventtypes = [...data.data.data.eventtypes];

          if (this.events.length && this.filter_type === "next") {
            this.next_event = this.events[0];
          }
          this.calendar_events = [...this.events].map((event) => {
            const start_date = new Date(event.date_start);
            const start_time =
              start_date.getHours() + ":" + start_date.getMinutes();

            const end_date = new Date(event.date_end);
            const end_time = end_date.getHours() + ":" + end_date.getMinutes();
            const settings = this.getEventTypeSetting(event.eventtype);
            return {
              key: event.id,
              highlight: {
                fillMode: "solid",
                style: {
                  backgroundColor: settings.color ?? "#4192d9",
                },
              },
              popover: {
                visibility: "hover",
              },
              dates: {
                start: start_date,
                end: end_date,
              },
              customData: {
                description:
                  event.title + " (" + start_time + " - " + end_time + ")",
              },
            };
          });
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
        });
    },

    absentieEvent(event) {
      event.attendees = event.attendees.map((user) => {
        user.selected = user.pivot.attend == 1 ? true : false;
        return user;
      });
      window.$("#absentieModal").modal("show");
    },
  },
  created() {
    this.nextEvent();
  },
};
</script>

<style scoped>
.tab-styling {
  padding: 5px !important;
  font-size: 16px !important;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;
  margin-top: 10px;
  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  margin-right: 10px;
  padding: 10px 0;
  width: auto;
}

.attendance {
  background: #6c6c6c 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.cursor-pointer {
  cursor: pointer;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 900px;
    margin: 1.75rem auto;
    margin-top: 9rem;
  }

  .delete-modal {
    max-width: 600px !important;
    margin: 1.75rem auto;
  }
}
</style>
